import React from "react";
import TechTypeLogoF from "../assets/TechTypeLogoF.png";

const TypeLogo = () => {
  return (
    <div>
      <img src={TechTypeLogoF} alt={TechTypeLogoF} style={{height: '250px'}}/>
    </div>
  );
};

export default TypeLogo;
